import useOnContextMenuOpen from './useOnContextMenuOpen';

export default useOnContextMenuOpen;